import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";
import ProjectsGallery from "@/components/ProjectsGallery";

const Projects = () => {
  const { t } = useLanguage();
  const p = t.projects;

  return (
    <div data-testid="projects-page" className="bg-cream">
      <section className="pt-40 md:pt-52 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <Kicker>{p.kicker}</Kicker>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mt-6 items-end">
            <Reveal delay={0.1} className="md:col-span-8">
              <h1 className="font-serif font-light text-5xl sm:text-6xl md:text-7xl text-charcoal leading-[1.02]">
                {p.title}
              </h1>
            </Reveal>
            <Reveal delay={0.2} className="md:col-span-4">
              <p className="text-charcoal/70 font-light leading-relaxed">
                {p.intro}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <ProjectsGallery testIdPrefix="project-card" />
        </div>
      </section>

      <section className="pb-28 md:pb-40">
        <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl text-charcoal leading-[1.05]">
              {t.contact.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link
              to="/contact"
              data-testid="projects-cta"
              className="inline-block mt-10 text-xs uppercase tracking-[0.18em] text-cream bg-olive hover:bg-charcoal transition-colors duration-300 px-10 py-5"
            >
              {t.contact.subtitle}
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Projects;
